import { AuthenticationService } from '@damofire/data-security';

export abstract class DivisionGuardService extends AuthenticationService {
  abstract canReadOrg(organization: string): Promise<boolean>;
  abstract canReadDivision(organization: string): Promise<boolean>;
}
